/* Tool 5: Can diabetics eat this? food checker. Registers into window.SKT2 (assets/sk-tools2.js).
   Food rows come from assets/sk-food-data.js, the same file the Glycemic Index Lookup and Carb Counter use. */
(function () {
  'use strict';
  var S = window.SKT2, D = window.SK_FOOD; if (!S || !D) return;
  var H = S.helpers, q = H.q, esc = H.esc, round = H.round, L = H.LINKS;
  var SERVINGS = [['0.5', '&frac12; serving'], ['1', '1 serving'], ['1.5', '1&frac12; servings'], ['2', '2 servings'], ['3', '3 servings']];

  /* name + aliases, lower case */
  var foods = D.foods.map(function (f, i) {
    var names = [f[0].toLowerCase()].concat((D.aliases[f[0]] || []).map(function (a) { return a.toLowerCase(); }));
    return { i: i, name: f[0], cat: f[1], gi: f[2], serving: f[3], carbs: f[4], names: names };
  });
  function gl(gi, carbs) { return gi == null ? null : round(gi * carbs / 100, 0); }

  /* tolerant matching: substring first, then up to one slip per word (banan, chapathi, mangoe) */
  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 1; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[m][n];
  }
  function search(term) {
    term = term.trim().toLowerCase(); if (!term) return [];
    var scored = [];
    foods.forEach(function (f) {
      var best = 99;
      f.names.forEach(function (n) {
        if (n === term) best = Math.min(best, 0);
        else if (n.indexOf(term) === 0) best = Math.min(best, 1);
        else if (n.indexOf(term) > -1) best = Math.min(best, 2);
        else {
          n.split(/[^a-z]+/).forEach(function (w) { if (w.length > 2 && term.length > 2 && lev(w, term) <= (term.length > 5 ? 2 : 1)) best = Math.min(best, 3); });
        }
      });
      if (best < 99) scored.push([best, f]);
    });
    return scored.sort(function (a, b) { return a[0] - b[0]; }).map(function (x) { return x[1]; }).slice(0, 6);
  }

  function verdict(g) {
    if (g == null) return { name: 'Judge by portion', kind: 'info', cls: 'info', text: 'The glycemic index of this food has not been measured, so judge it by the carbs in your portion.' };
    if (g <= 10) return { name: 'Good choice in this portion', kind: 'good', cls: 'good', text: 'The glycemic load is low, so this portion is unlikely to push your blood sugar up much.' };
    if (g < 20) return { name: 'Have a smaller portion or pair it', kind: 'warn', cls: 'warn', text: 'The glycemic load is moderate. A smaller portion, or pairing it with protein or fibre, keeps the rise gentler.' };
    return { name: 'Better to limit. Try a swap', kind: 'alert', cls: 'alert', text: 'The glycemic load is high in this portion. A smaller portion or one of the swaps below will be kinder to your blood sugar.' };
  }
  function swaps(f) {
    if (f.gi == null) return [];
    var cur = gl(f.gi, f.carbs);
    return foods.filter(function (o) { return o.i !== f.i && o.cat === f.cat && o.gi != null && gl(o.gi, o.carbs) <= cur * 0.7; })
      .sort(function (a, b) { return gl(a.gi, a.carbs) - gl(b.gi, b.carbs); }).slice(0, 3);
  }

  S.tools.foodcheck = function (root) {
    var chosen = null, n = '1', withWhat = 'alone';
    var r = H.frame(root, 'foodcheck',
      '<div class="tl-field t2-field" id="f-fc"><label for="fc">Search a food</label><div class="t2-in"><input type="text" id="fc" autocomplete="off" placeholder="e.g. mango, aam, roti, chawal" aria-autocomplete="list" aria-controls="fc-list" style="padding-right:14px"></div>' +
      '<small>Works in English, Hindi and Kannada: aam, maavina hannu, kela, chawal.</small><span class="t2-err" id="e-fc" role="alert"></span>' +
      '<ul class="tl-foods" id="fc-list" role="listbox" style="margin-top:6px"></ul></div>' +
      '<div id="fc-picked"></div>' +
      H.fld('How much?', H.seg('fc-n', SERVINGS, '1'), 'A serving is the household measure shown above (one katori, one medium fruit and so on).') +
      H.fld('Eaten with', H.seg('fc-with', [['alone', 'Alone'], ['meal', 'With a meal'], ['pf', 'With protein or fat (curd, nuts, dal)']], 'alone', 'tl-ropts')),
      {
        steps: false,
        go: 'Check this food',
        onReset: function () { chosen = null; q('#fc-picked', root).innerHTML = ''; q('#fc-list', root).innerHTML = ''; },
        calc: function (ctx) {
          var box = q('#f-fc', root), err = q('#e-fc', root);
          if (!chosen) {
            var m = search(q('#fc', root).value); if (m.length === 1) chosen = m[0];
          }
          if (!chosen) { box.classList.add('t2-field--err'); err.textContent = 'Search for a food and tap it from the list.'; ctx.bad = true; ctx.first = q('#fc', root); return null; }
          box.classList.remove('t2-field--err'); err.textContent = '';
          var f = chosen, k = parseFloat(H.sv(root, 'fc-n')) || 1, w = H.sv(root, 'fc-with');
          var carbs = round(f.carbs * k, 1), g = gl(f.gi, carbs), v = verdict(g), sw = swaps(f);
          var tip = w === 'pf' ? H.note('info', 'Pairing tip', 'Pairing it with protein or fat slows the rise. It does not change the number above.') : w === 'meal' ? '<p class="t2-fine">Eaten as part of a meal, the rise is usually slower than the number suggests.</p>' : '';
          var swapHtml = sw.length ? '<h3 class="t2-fine" style="font-weight:800">Lower-load swaps</h3><div class="t2-chips" id="fc-swaps">' + sw.map(function (o) { return '<button type="button" data-i="' + o.i + '">' + esc(o.name) + ' (GL ' + gl(o.gi, o.carbs) + ')</button>'; }).join('') + '</div>' : (v.kind === 'alert' ? '<p class="t2-fine">No lower-load swap in this group yet.</p>' : '');
          var fruitOrSweet = f.cat === 3 || f.cat === 5;
          var cta = [{ k: 'consult', href: L.consult, label: 'Want a full meal plan? Free consultation', primary: !fruitOrSweet }];
          if (fruitOrSweet) cta.unshift({ k: 'product', href: L.tea, label: 'A caffeine-free cup for after meals', primary: true });
          cta.push({ k: 'tool', href: L.carb, label: 'Add to Carb Counter' });
          return '<p class="t2-range">' + esc(f.name) + ': ' + v.name + '<small>' + k + ' &times; ' + esc(f.serving) + '</small></p>' +
            H.stats([H.stat('Carbs in portion', carbs, 'g'), H.stat('Glycemic index', f.gi == null ? '-' : f.gi), H.stat('Glycemic load', g == null ? '-' : g)]) +
            H.note(v.kind, v.name, v.text) + tip + swapHtml +
            H.ctas(cta, 'I checked ' + f.name + ' (' + k + ' x ' + f.serving + ') on the Sugar Knocker food checker: ' + carbs + ' g carbs' + (g == null ? '' : ', glycemic load ' + g) + '.');
        }
      });
    var inp = q('#fc', root), list = q('#fc-list', root), picked = q('#fc-picked', root);
    function pick(f) {
      chosen = f; inp.value = f.name; list.innerHTML = '';
      picked.innerHTML = '<div class="tl-note tl-note--info" style="margin:8px 0 14px"><strong>' + esc(f.name) + '</strong>One serving: ' + esc(f.serving) + ', about ' + f.carbs + ' g carbs' + (f.gi == null ? '' : ', GI ' + f.gi) + '.</div>';
    }
    inp.addEventListener('input', function () {
      chosen = null; picked.innerHTML = '';
      var m = search(inp.value);
      list.innerHTML = m.map(function (f) { return '<li><button type="button" class="tl-food" data-i="' + f.i + '" role="option" style="width:100%;text-align:left;cursor:pointer;background:#fff"><span class="tl-food__name">' + esc(f.name) + '</span><span class="tl-food__meta">' + esc(f.serving) + '</span></button></li>'; }).join('');
    });
    list.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) pick(foods[+b.getAttribute('data-i')]); });
    /* tapping a swap chip re-runs the check on that food */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('#fc-swaps button'); if (!b) return;
      pick(foods[+b.getAttribute('data-i')]); r.form.requestSubmit();
    });
  };
})();
